import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { GlassHouseShelfTalkerPostCardBackgroundViewModel } from './glass-house-shelf-talker-post-card-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import { GroupedByBrandShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';

@Component({
  selector: 'app-glass-house-shelf-talker-post-card-background',
  templateUrl: './glass-house-shelf-talker-post-card-background.component.html',
  styleUrl: './glass-house-shelf-talker-post-card-background.component.scss',
  providers: [GlassHouseShelfTalkerPostCardBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseShelfTalkerPostCardBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: GlassHouseShelfTalkerPostCardBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GroupedByBrandShelfTalkerCardData;
}
